import React from "react";
import "./OurVisionStyle.scss";
import { ourVisionSectionTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const OurVisionSectionSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="our-vision-section">
      <div className="our-vision-wrap">
        <SectionHeading>{ourVisionSectionTextContent.headingText}</SectionHeading>

        <div className="our-vision-box">
          <div className="text-box">
            <p className="para-text">{ourVisionSectionTextContent.paraText}</p>

            <div className="btn-box">
              <CustomButton
                buttonType="black"
                label={ourVisionSectionTextContent.btnText}
                onClick={handleButtonClick}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurVisionSectionSection;
